import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['project', 'select']
  static values = {
    dom: { type: String, default: 'test_plans_project_' }
  }

  connect () {
    this.showSelectedProject()
  }

  showSelectedProject () {
    const projectId = this.domValue + this.selectTarget.value
    this.projectTargets.forEach(project => {
      if (project.id === projectId) {
        project.classList.remove('hidden')
      } else {
        project.classList.add('hidden')
      }
    })
  }
}
